import './styles.scss';
import React, { ButtonHTMLAttributes } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  small?: boolean;
  gray?: boolean;
  icon?: JSX.Element;
  loading?: boolean;
  postfix?: string | JSX.Element;
};

const Button = (props: Props) => {
  const { small, gray, icon, loading, postfix, ...domProps } = props;

  const className = [
    'local_button__base',
    small ? 'local_button__small' : '',
    gray ? 'local_button__gray' : '',
    postfix ? 'relative' : '',
    domProps.className ?? ''
  ].join(' ');

  return (
    <button {...domProps} className={className} disabled={props.disabled || loading}>
      {loading ? (
        'loading...'
      ) : (
        <>
          {icon ? icon : null}
          {props.children}
          <span className='absolute right-5'>{postfix}</span>
        </>
      )}
    </button>
  );
};

export default Button;
